import { jwtDecode } from "jwt-decode";

function getClaim(decoded, names) {
  for (const name of names) {
    if (decoded?.[name]) return decoded[name];
  }

  return null;
}

function buildProfile(payload, decoded) {
  const usuario = payload?.usuario ?? payload?.user ?? null;
  const nome = usuario?.nome ?? getClaim(decoded, ["nome", "name", "unique_name"]) ?? "Usuário";
  const login = usuario?.login ?? getClaim(decoded, ["unique_name", "name"]) ?? "";
  const perfil = usuario?.perfil ?? getClaim(decoded, ["perfil", "role", "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]) ?? "Usuario";

  return {
    id: usuario?.id ?? getClaim(decoded, ["nameid", "sub", "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]),
    nome,
    name: nome,
    primeiroNome: String(nome).split(" ")[0],
    login,
    perfil,
  };
}

function Reducer(state, action) {
  if (Array.isArray(action)) {
    action.forEach((item) => {
      state = Reducer(state, item);
    });
    return state;
  }

  switch (action.type) {
    case "SET_READY":
      return { ...state, ready: action.payload };
    case "SET_PROFILE":
      return { ...state, profile: action.payload };
    case "SET_LOGGED": {
      const token = action.payload?.token ?? action.payload?.accessToken ?? action.payload;
      const refreshToken = action.payload?.refreshToken ?? (typeof action.payload === "string" ? localStorage.getItem("refreshToken") : null);
      let isLogged = false;
      let jwt = null;
      let profile = null;
      let jwtDecoded = null;
      let activeRefreshToken = null;

      if (typeof token === "string" && token) {
        try {
          jwtDecoded = jwtDecode(token);
        } catch {
          localStorage.removeItem("jwt");
          localStorage.removeItem("refreshToken");
          return { ...state, jwtDecoded: null, isLogged: false, jwt: null, refreshToken: null, profile: null };
        }

        const now = Date.now() / 1000;
        const expirado = jwtDecoded.exp && jwtDecoded.exp < now;

        if (!expirado) {
          isLogged = true;
          jwt = token;
          profile = buildProfile(action.payload, jwtDecoded);
          localStorage.setItem("jwt", jwt);
          if (refreshToken) {
            activeRefreshToken = refreshToken;
            localStorage.setItem("refreshToken", refreshToken);
          }
        } else {
          localStorage.removeItem("jwt");
          localStorage.removeItem("refreshToken");
        }
      } else {
        localStorage.removeItem("jwt");
        localStorage.removeItem("refreshToken");
      }

      return {
        ...state,
        jwtDecoded,
        isLogged,
        jwt,
        refreshToken: activeRefreshToken,
        profile,
      };
    }
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}

export default Reducer;
